module.exports = __webpack_public_path__ + "jay-fddd7e2fe7cec6293771.jpg";